import casgrainImage from "../../assets/images/casgrain4mayor.webp";
import tabImage from "../../assets/images/TabTabTab.png";
import moodImage from "../../assets/images/mood-image.png";

import casgrainDemo from "../../assets/images/c-demo.mp4";
import tabDemo from "../../assets/images/tab-demo.mp4";
import moodDemo from "../../assets/images/m-demo.mp4";

const PROJECTS = [
  {
    id: 1,
    className: "main__proj-1",
    name: "Lynne Casgrain Campaign Website",
    description:
      "Bilingual campaign website focused on accessibility, scalability, and responsive design.",
    fullDescription:
      "Public-facing bilingual campaign site emphasizing accessibility, scalability, and responsive design, deployed with Cloudflare Pages and Workers.",
    ariaLabel: "Open project details for Lynne Casgrain Campaign Website",
    image: casgrainImage,
    imageAlt: "Preview of the Lynne Casgrain Campaign Website homepage",
    modalVideo: casgrainDemo,
    modalWidth: 800,
    modalHeight: 798,
    modalImageAlt: "Animated preview of the Lynne Casgrain Campaign Website",
    liveUrl: "https://casgrain-mayor-campaign.pages.dev/en",
    githubUrl: null,
    extraLinks: [],
  },
  {
    id: 2,
    className: "main__proj-2",
    name: "TabTabTab",
    description:
      "Chrome extension and full-stack app for saving and organizing tabs.",
    fullDescription:
      "A project consisting of a Chrome extension, a web app, and its own server and database. Instead of keeping hundreds of tabs open in your browser, you can save them to TabTabTab and come back later.",
    ariaLabel: "Open project details for TabTabTab",
    image: tabImage,
    imageAlt: "Preview of the TabTabTab application",
    modalVideo: tabDemo,
    modalWidth: 600,
    modalHeight: 582,
    modalImageAlt: "Animated preview of the TabTabTab application",
    liveUrl: "https://tabtabtab-chk.herokuapp.com/",
    githubUrl: "https://github.com/chanho-chris-kim/tabtabtab",
    extraLinks: [],
  },
  {
    id: 3,
    className: "main__proj-3",
    name: "Mood Image",
    description:
      "AI-powered music mood visualizer that matches songs with animated content.",
    fullDescription:
      "A team project created with Nick Macdonald. It is a music player that detects the mood of a song using an AI API, finds a matching Simpsons GIF, and displays it.",
    ariaLabel: "Open project details for MOOD IMAGE",
    image: moodImage,
    imageAlt: "Preview of the MOOD IMAGE application",
    modalVideo: moodDemo,
    modalWidth: 600,
    modalHeight: 580,
    modalImageAlt: "Animated preview of the MOOD IMAGE music player",
    liveUrl: null,
    githubUrl: "https://github.com/chanho-chris-kim/mood-image",
    extraLinks: [
      {
        label: "Nick Macdonald",
        href: "https://www.linkedin.com/in/nicholas-teo-macdonald/",
        type: "collaborator_link",
      },
    ],
  },
];

export default PROJECTS;
